import React, { useRef } from "react";
import Slider from "react-slick";
import { properties } from "./../properties";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";

const PropertiesSlider = () => {
  const sliderRef = useRef(null);

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  };

  const handlePrev = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  const handleNext = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  return (
    <section
      className="space space-extra-bottom bg-light shape-mockup-wrap"
      style={{ backgroundImage: "url(/assets/img/shape/Bg.png)" }}
    >
      <div
        className="shape-mockup d-none d-xl-block spin z-index-negative"
        style={{ top: "-20%", right: "-8%" }}
      >
        <img src="/assets/img/shape/circle1.png" alt="circle" />
      </div>
      <div
        className="shape-mockup d-none d-xl-block z-index-negative"
        style={{ bottom: "13%", left: "0%" }}
      >
        <img src="/assets/img/shape/walk.png" alt="circle" />
      </div>

      <div className="container">
        <div className="row justify-content-between align-items-center">
          <div className="col-lg-5 col-md-8">
            <div className="title-area">
              <span className="sec-subtitle">Discover Our Properties</span>
              <h2 className="sec-title h1">Available Properties</h2>
            </div>
          </div>

          <div className="col-auto">
            <div className="sec-btns">
              <button className="icon-btn" onClick={handlePrev}>
                <i className="fas fa-chevron-left"></i>
              </button>
              <button className="icon-btn" onClick={handleNext}>
                <i className="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>

        <Slider
          {...sliderSettings}
          className="destinationSlide custom-slider"
          ref={sliderRef}
        >
          {properties.map((property) => (
            <div key={property.id}>
              <div className="destination-style1">
                <Link to={property.link}>
                  <img src={property.imageUrl} alt={property.name} />
                </Link>
                <div className="destination-info">
                  <h4 className="destination-name">
                    <Link to={property.link}>{property.name}</Link>
                  </h4>
                  <p className="destination-text">{property.description}</p>
                  <p className="destination-location text-white">
                    {property.location}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default PropertiesSlider;
